const config = {
  rpcUrl: "https://api.devnet.solana.com",
  ownershipTransferAddress: "1nc1nerator11111111111111111111111111111111",
  warContributionAddress: "1nc1nerator11111111111111111111111111111111",
};

export default config;
